import { MessageParameters, MessageResponse } from "@boi/shared-models";
import { CommonAxiosService } from "../common-axios-service";
import axios from "axios";


export class WhatsAppNotificationService extends CommonAxiosService{
    // whatsappbiMessageURL = 'http://206.189.138.212:3232/api/bi-message';

    private getURLwithMainEndPoint(childUrl: string) {
        return 'http://206.189.138.212:3232/api/bi-message' + childUrl;
    }

    async sendMessageThroughFbApi(message:MessageParameters ): Promise<MessageResponse> {
        return await axios.post(`https://graph.facebook.com/v17.0/168595539660514/messages`, {
            "messaging_product": "whatsapp",
            "to": message.recepients,
            "type": "template",
            "template": {
                "name": message.template,
                "language": {
                    "code": message.languageCode ? message.languageCode : "en_us"
                },
                "components": [
                    {
                        "type": "body",
                        "parameters": message.parameters,
                    }
                ]
            }
        }, {
            "headers": {
                'Authorization': `EAABtPfqQEJ0BO6obSjOyxHge99JAApPEZCLBGx5eMuiRYaMH1zeYJVZAFNTF034eD4Sn2HH9ymIWNqVkWtVXJyPSxKXvffaZCC5XVLpkx2fWCeDMT8bRP9chiFsMydZAh2ogvSc7WPlAHtCJlgFRBvl1UFtPqt2RAnTGy6NA9VLzsxD0h2ZAjoTZBVWKsb5K7bu72es4w1ZCZAa9ZAYZCR`,
                'Content-Type': 'application/json'
            },
        }).then((res) => {
            return res.data;
        }).catch(err => { return err });
    }
}